export default {
  NO_DATA: 'No data',
  NO_MATCHED_STOCK: 'No matched stock',
  NO_MATCHED_CW: 'No matched covered warrant',
  DONE: 'DONE',
  CANCEL: 'CANCEL',
  CREATE: 'CREATE',
  YES: 'YES',
  table: {
    TABLE_FOOTER_TEXT: 'Price: x 1,000. Volume: x 1,000. Value: x 1,000,000',
    TABLE_FOOTER_TEXT_WITH_UNIT:
      'Price: x1000 (VND). Volume: x1000 (Shares). Value: x1000000 (VND)',
    SIMPLE_TABLE_FOOTER_TEXT: 'Price: x 1,000. Volume: x 1,000',
    NO_DATA: 'No data',
    ZMF_SCORE_TEXT:
      'For more details on how to utilize Z-Score, M-Score and F-Score',
  },
  button: {
    delete: 'DELETE',
    cancel: 'CANCEL',
    save: 'SAVE',
  },
  lstLabelCalendar: {
    from: 'From',
    to: 'To',
    startDate: 'Start Date',
    endDate: 'End Date',
    apply: 'Apply',
    formatDate: 'MM/DD/YYYY',
  },
  searchAdd: {
    search: 'Search',
    add: 'Add',
  },
  search: 'Search',
  listComponent: {
    Market: 'MARKET',
    Price: 'PRICES',
    Fundamental: 'FUNDAMENTAL',
    Technical: 'TECHNICAL',
    NewsAndAnalysis: 'NEWS AND ANALYSIS',
    Tools: 'TOOLS',
    ST: 'STRATEGY',
    MarketInDepth: 'Market In-Depth',
    Watchlist: 'Watchlist',
    TopVolume: 'Top Volume',
    TopBreakout: 'Top Breakout',
    TopValue: 'Top Value',
    TopGainers: 'Top Gainers',
    TopLosers: 'Top Losers',
    TopNewHigh: 'Top New High',
    TopNewLow: 'Top New Low',
    TopForeignTrade: 'Top Foreign Trading',
    MarketCalendar: 'Market Calendar',
    HeatMap: 'Heat Map',
    MoneyFlow: 'Money Flow',
    TimeAndSales: 'Time & Sales',
    PriceDepth: 'Price Depth',
    QuoteMovement: 'Quote Movement',
    PriceData: 'Price Data',
    Charting: 'Charting',
    FADividendAnalysis: 'Cash Dividend Analysis',
    TASignals: 'Technical Analysis',
    FinancialAnalysis: 'Financial Analysis',
    FinancialRatio: 'Financial Ratio',
    Ownership: 'Ownership',
    FinancialStatement: 'Financial Statement',
    FASnapshot: 'Snapshot',
    News: 'News',
    Alerts: 'Alerts',
    Screener: 'Stock Screener',
    Valuation: 'Valuation',
    ConsensusAnalysis: 'Consensus Analysis',
    STRanking: 'Ranking',
    Strategy: 'Strategy',
    TradeData: 'FiinTA',
    Order: 'Order',
  },
  minutes: 'minutes',
  seconds: 'seconds',
  marketPreOpenTitle: 'The market will be open in',
  labelPopupDragComponent: 'Drag to location or',
  pressEscToExit: 'Press [Esc] to exit.',
  POPOUT: 'Popout',
  TITLE_POPUP_BUY_SELL: 'CHOOSE YOUR SECURITIES FIRM',
  TITLE_POPUP_TUTORIAL: 'FIINTRADE TUTORIAL',
  EXPORT: 'EXPORT',
  PRINT: 'PRINT',
  headline: 'Headline',
  buy: 'BUY',
  sell: 'SELL',
  points: 'POINTS',
  watchOut: {
    title: 'WATCH OUT',
    description: 'Has been listed in the',
  },
  close: 'close',
  maximise: 'maximise',
  minimise: 'minimise',
  popout: 'open in new window',
  shareOnSkype: 'Share on Skype',
  export: {
    marketIndepth: {
      valuation: 'FiinTrade_Valution_%{date}',
    },
    topMover: {
      1: 'FiinTrade_%{name}_Overview_%{date}',
      2: 'FiinTrade_%{name}_Performance_%{date}',
      3: 'FiinTrade_%{name}_Financial_%{date}',
      4: 'FiinTrade_%{name}_Technical_%{date}',
    },
    timesAndSales: 'FiinTrade_Time&Sales_%{ticker}_%{date}',
    priceData: {
      1: 'FiinTrade_Price_%{ticker}_%{date}',
      2: 'FiinTrade_Orders_%{ticker}_%{date}',
      3: 'FiinTrade_Foreign_%{ticker}_%{date}',
      4: 'FiinTrade_Proprietary_%{ticker}_%{date}',
    },
    snapshot: 'FiinTrade_Snapshot_%{ticker}_%{date}',
    ownership: {
      1: 'FiinTrade_Major_Shaerholders_%{ticker}_%{date}',
      2: 'FiinTrade_Board_of_Directors_%{ticker}_%{date}',
    },
    financialAnalysis: {
      financialRatio: 'FiinTrade_Financial_Ratio_%{ticker}_%{date}',
      zmfScore: 'FiinTrade_ZMF_Score_%{ticker}_%{date}',
    },
    cashDividendAnalysis: 'FiinTrade_Cash_Dividend_Analysis_%{ticker}_%{date}',
    financialStatement: {
      balanceSheet: 'FiinTrade_Balance_Sheet_%{ticker}_%{date}',
      incomeStatement: 'FiinTrade_Income_Statement_%{ticker}_%{date}',
      cashFlowStatement: 'FiinTrade_Cash_Flow_Statement_%{ticker}_%{date}',
    },
    stockScreener: {
      1: 'FiinTrade_StockScreener_Result_%{date}',
      2: 'FiinTrade_StockScreener_Performance_%{date}',
      3: 'FiinTrade_StockScreener_Financial_%{date}',
      4: 'FiinTrade_StockScreener_Technical_%{date}',
    },
    ranking: {
      fiinTradeRankings: 'FiinTrade_FiinTradeRanking_%{group}_%{date}',
      all: 'FiinTrade_AllScore_All_%{date}',
      hose: 'Fiintrade_AllScore_HOSE_%{date}',
      hnx: 'Fiintrade_AllScore_HNX_%{date}',
    },
    strategy: {
      value: 'FiinTrade_Value_%{date}',
      growth: 'FiinTrade_Growth_%{date}',
      momentum: 'FiinTrade_Momentum_%{date}',
      vgm: 'FiinTrade_VGM_%{date}',
      leaders: 'FiinTrade_Leaders_%{date}',
      canSlim: 'FiinTrade_Canslim_%{date}',
    },
  },
  bullish: 'Bullish',
  bearish: 'Bearish',
  strongBullish: 'Strong Bullish',
  strongBearish: 'Strong Bearish',
  neutral: 'Neutral',
  all: 'All',
  login: 'Login',
  buyUp: 'Buy Up',
  sellDown: 'Sell Down',
  price: 'Price',
  time: 'Time',
  busd: {
    volume: 'Volume (Thousand)',
    price: 'Price',
    index: 'Index',
  },
  noData: 'No data available',
  listComponentWithTab: {
    marketInDepth: {
      index: 'Market In-Depth/Index',
      prospect: 'Market In-Depth/Prospect',
      valuation: 'Market In-Depth/Valuation',
      liquidity: 'Market In-Depth/Liquidity',
      marketAnomaly: 'Market In-Depth/Market Anomaly',
    },
    topVolume: {
      overview: 'Top Volume/Overview',
      performance: 'Top Volume/Performance',
      financial: 'Top Volume/Financial',
      technical: 'Top Volume/Technical',
      chart: 'Top Volume/Chart',
    },
    TopBreakout: {
      overview: 'Top Breakout/Overview',
      performance: 'Top Breakout/Performance',
      financial: 'Top Breakout/Financial',
      technical: 'Top Breakout/Technical',
      chart: 'Top Breakout/Chart',
    },
    TopValue: {
      overview: 'Top Value/Overview',
      performance: 'Top Value/Performance',
      financial: 'Top Value/Financial',
      technical: 'Top Value/Technical',
      chart: 'Top Value/Chart',
    },
    TopGainers: {
      overview: 'Top Gainers/Overview',
      performance: 'Top Gainers/Performance',
      financial: 'Top Gainers/Financial',
      technical: 'Top Gainers/Technical',
      chart: 'Top Gainers/Chart',
    },

    TopLosers: {
      overview: 'Top Losers/Overview',
      performance: 'Top Losers/Performance',
      financial: 'Top Losers/Financial',
      technical: 'Top Losers/Technical',
      chart: 'Top Losers/Chart',
    },
    TopNewHigh: {
      overview: 'Top New high/Overview',
      performance: 'Top New high/Performance',
      financial: 'Top New high/Financial',
      technical: 'Top New high/Technical',
      chart: 'Top New high/Chart',
    },
    TopNewLow: {
      overview: 'Top New low/Overview',
      performance: 'Top New low/Performance',
      financial: 'Top New low/Financial',
      technical: 'Top New low/Technical',
      chart: 'Top New low/Chart',
    },
    TopForeignTrade: {
      overview: 'Top Foreign Trading/Overview',
      performance: 'Top Foreign Trading/Performance',
      financial: 'Top Foreign Trading/Financial',
      technical: 'Top Foreign Trading/Technical',
      chart: 'Top Foreign Trading/Chart',
    },
    HeatMap: {
      marketCap: 'Heat Map/Market Cap',
      volume: 'Heat Map/Volume',
      value: 'Heat Map/Value',
      buyVol: 'Heat Map/Fr. Buy Vol.',
      sellVol: 'Heat Map/Fr. Sell Vol.',
      buyVal: 'Heat Map/Fr. Buy Val.',
      sellVal: 'Heat Map/Fr. Sell Val.',
    },

    MoneyFlow: {
      contribution: 'Money Flow/Contribution',
      foreign: 'Money Flow/Foreign',
      proprietary: 'Money Flow/Proprietary',
    },

    TimeAndSales: {
      name: 'Time & Sales',
    },

    PriceDepth: {
      name: 'Price Depth',
    },

    PriceData: {
      overview: 'Price Data/Overview',
      orderStatistic: 'Price Data/Order Statistic',
      foreign: 'Price Data/Foreign',
      proprietary: 'Price Data/Proprietary',
    },

    Charting: {
      name: 'Charting',
    },

    TASignals: {
      indicatorSignal: 'Technical Analysis/Indicators Signal',
      deceptive: {
        overview: 'Technical Analysis/Deceptive Orders/Overview',
        cefl: 'Technical Analysis/Deceptive Orders/CE/FL Abnormality',
        cancelled: 'Technical Analysis/Deceptive Orders/Cancelled',
        pressing: 'Technical Analysis/Deceptive Orders/Pressing',
        aggressive: 'Technical Analysis/Deceptive Orders/Aggressive',
        closing: 'Technical Analysis/Deceptive Orders/Closing',
      },
      priceVolumeAnalysis: 'Technical Analysis/Price-Volume Analysis',
    },
    News: {
      fiintradeDiary: 'News/FiinTrade Diary',
      fiintradeCall: 'News/FiinTrade Call',
      autoNews: 'News/Auto News',
      newsAggregator: 'News/News Aggregator',
    },
    FASnapshot: {
      name: 'Company Snapshot',
    },
    Ownership: {
      majorShareholder: 'Ownership/Major Shareholders',
      bod: 'Ownership/Board of directors',
    },
    FinancialAnalysis: {
      FACheckup: 'Financial Analysis/FA Checkup',
      ZMFScore: 'Financial Analysis/ZMF-Score',
    },
    FinancialRatio: {
      name: 'Financial Ratio',
    },
    FADividendAnalysis: {
      name: 'Cash Dividend Analysis',
    },
    ConsensusAnalysis: {
      name: 'Consensus Analysis',
    },
    FinancialStatement: {
      balanceSheet: 'Financial Statement/Balance Sheet',
      incomeStatement: 'Financial Statement/Income Statement',
      cashFlowStatement: 'Financial Statement/Cash Flow Statement',
    },
    Alerts: {
      name: 'Alerts',
    },
    Screener: {
      name: 'Stock Screener',
    },
    Valuation: {
      name: 'Valuation',
    },
    TradeData: {
      name: 'FiinTA',
    },
    STRanking: {
      fiintradeRanking: 'Ranking/FiinTrade Rankings',
      allScore: 'Ranking/All Score',
    },
    Strategy: {
      fiintradeStrategy: {
        overview: 'Strategy/FiinTrade Strategy/Overview',
        value: 'Strategy/FiinTrade Strategy/Value',
        growth: 'Strategy/FiinTrade Strategy/Growth',
        momentum: 'Strategy/FiinTrade Strategy/Momentum',
        vgm: 'Strategy/FiinTrade Strategy/VGM',
        leaders: 'Strategy/FiinTrade Strategy/Leaders',
      },
      canSlim: 'Strategy/CANSLIM Strategy',
      taStrategy: {
        accummulation: 'Strategy/TA Strategy/Accummulation',
        breakout: 'Strategy/TA Strategy/Breakout',
        breakoutMA: 'Strategy/TA Strategy/Breakout MA',
        bestInDowntrend: 'Strategy/TA Strategy/Best in downtrend',
        marketAnomaly: 'Strategy/TA Strategy/Market Anomaly',
      },
    },
  },
  poweredByFiinTrade: `Powered by `,
};
